/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Loader, Modal } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import api from '../../api';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import WithRouter from '../Extensions/WithRouter';

class CryptographySetting extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.state = {
      isLoading: false,
      isUseCrypto: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSaveModal = this.handleSaveModal.bind(this);
    this.updateUseCryptoStatus = this.updateUseCryptoStatus.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.getUseCryptoStatus();
  }

  componentDidUpdate() {}

  handleToggle(e) {
    const { t } = this.props;
    const { isUseCrypto } = this.state;

    const clickedText = e.target.text;

    if (clickedText === t('modal.button.on')) {
      if (!isUseCrypto) {
        this.setState({ isUseCrypto: true });
      }
    } else if (clickedText === t('modal.button.off')) {
      if (isUseCrypto) {
        this.setState({ isUseCrypto: false });
      }
    }
  }

  handleSaveModal() {
    const { t } = this.props;
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('settings.message.save_setting');
    this.setState({
      isOpenModal: true,
    });
  }

  getUseCryptoStatus() {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getUseCryptoStatus()
          .then((response) => {
            const res = convertPropertiesToCamelCase(response.response);
            const { useCrypto } = res;
            this.setState({
              isLoading: false,
              isUseCrypto: useCrypto,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoading: false,
            });
          });
      }
    );
  }

  updateUseCryptoStatus() {
    const { isUseCrypto } = this.state;
    const { state } = this.props;

    const data = {
      use_crypto: isUseCrypto,
    };

    this.setState(
      {
        isOpenModal: false,
        isLoading: true,
      },
      () => {
        api
          .updateUseCryptoStatus(data)
          .then((response) => {
            const res = convertPropertiesToCamelCase(response.response);
            localStorage.setItem('use_crypto', res.useCrypto);
            state.user.setUseCrypto(res.useCrypto);

            this.setState({
              isLoading: false,
              isUseCrypto: res.useCrypto,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoading: false,
            });
          });
      }
    );
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
      isOpenAlert: false,
    });
  }

  render() {
    const { isLoading, isUseCrypto } = this.state;
    const { t } = this.props;
    const { isAdmin } = this.props.state.user;

    const renderIfReady = (element) => {
      return isLoading ? (
        <div className="loader_container">
          <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
            {t('list.title.loading')}
          </Loader>
        </div>
      ) : (
        element
      );
    };

    return (
      <div className="setting_issue_main" style={{ position: 'relative' }}>
        <div className="contents_header">
          <div className="contents_header_inner">
            <h3 className="content_title">
              {t('settings.list.crypto_setting_title')}
            </h3>
          </div>
        </div>
        {renderIfReady(
          <div className="setting_issues_content">
            <div className="setting_issues_content_item_wrap">
              <div className="setting_issues_content_item">
                {isAdmin ? (
                  <div className="switch">
                    <a
                      className={cx({
                        checked: isUseCrypto,
                      })}
                      onClick={this.handleToggle}
                      onKeyUp={this.handleToggle}
                    >
                      {t('modal.button.on')}
                    </a>
                    <a
                      className={cx({
                        checked: !isUseCrypto,
                      })}
                      onClick={this.handleToggle}
                      onKeyUp={this.handleToggle}
                    >
                      {t('modal.button.off')}
                    </a>
                  </div>
                ) : (
                  <div className="switch">
                    <a
                      className={cx(
                        {
                          checked: isUseCrypto,
                        },
                        'disable'
                      )}
                    >
                      {t('modal.button.on')}
                    </a>
                    <a
                      className={cx(
                        {
                          checked: !isUseCrypto,
                        },
                        'disable'
                      )}
                    >
                      {t('modal.button.off')}
                    </a>
                  </div>
                )}
                {isUseCrypto ? (
                  <p className="text">
                    {t('settings.message.crypto_setting_on_msg')}
                  </p>
                ) : (
                  <p className="text">
                    {t('settings.message.crypto_setting_off_msg')}
                  </p>
                )}
              </div>
            </div>
            {isAdmin ? (
              <div
                className="setting_issues_bottom"
                style={{ bottom: '-260px', position: 'absolute' }}
              >
                <a
                  className="save"
                  onClick={this.handleSaveModal}
                  onKeyUp={this.handleSaveModal}
                >
                  {t('modal.button.save')}
                </a>
              </div>
            ) : null}
          </div>
        )}
        <Modal open={this.state.isOpenModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="left_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.cancel')}
                  </a>
                  <a
                    className="right_button"
                    onClick={this.updateUseCryptoStatus}
                    onKeyUp={this.updateUseCryptoStatus}
                  >
                    {t('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={this.state.isOpenAlert} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(
  withTranslation()(inject('state')(observer(CryptographySetting)))
);
